export default {
  pageOrNotFound: {
    notFound: 'Não encontrado'
  }
}
